module.exports = __webpack_public_path__ + "img/chadle3_3.6f8fe5dc.png";